import { useCallback, useState } from 'react';

import { confluenceLocalStorageInstance as localStorage } from '@confluence/storage-manager/entry-points/storageInstance.ts';
import { PERSISTED_KEYS_ON_SERVER } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';

const getIsDismissed = () =>
	String(localStorage?.getItem(PERSISTED_KEYS_ON_SERVER.PERSISTED_MOBILE_APP_PROMO_DISMISSED)) ===
	'true';

export const useMobileAppPromoDismiss = () => {
	const [isDismissed, setIsDismissed] = useState<boolean>(getIsDismissed);

	const onMobileAppPromoDismiss = useCallback(() => {
		localStorage?.setItem(PERSISTED_KEYS_ON_SERVER.PERSISTED_MOBILE_APP_PROMO_DISMISSED, 'true');
		setIsDismissed(true);
	}, []);

	return { isMobileAppPromoDismissed: isDismissed, onMobileAppPromoDismiss };
};
